import React from "react";
import { Col, Row } from "react-bootstrap";
import { DiPython, DiGit, DiJava } from "react-icons/di";
import { GrDocker } from "react-icons/gr";
import { FaB } from "react-icons/fa6";

import {
  SiPytorch,
  SiScikitlearn,
  SiTensorflow,
  SiMysql,
} from "react-icons/si";

function CheatSheet() {
  function openInNewTab(url) {
    window.open(url, "_blank", "noopener,noreferrer");
  }
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col
        xs={4}
        md={2}
        className="tech-icons"
        onClick={() =>
          openInNewTab(
            "https://drive.google.com/file/d/1m6a_V2rmXPYnjs5K0mn3yqGLhCk2EwV9/view?usp=drive_link"
          )
        }
      >
        <SiTensorflow />
      </Col>
      <Col
        xs={4}
        md={2}
        className="tech-icons"
        onClick={() =>
          openInNewTab(
            "https://drive.google.com/file/d/1DImpI_vKm7wwv7970EnCGxdPGjzQum1f/view?usp=drive_link"
          )
        }
      >
        <DiPython />
      </Col>
      <Col
        xs={4}
        md={2}
        className="tech-icons"
        onClick={() =>
          openInNewTab(
            "https://drive.google.com/file/d/1pGqurEa0BvLpAQ0AMigHIHcrku2vVQUQ/view?usp=drive_link"
          )
        }
      >
        <SiScikitlearn />
      </Col>
      <Col
        xs={4}
        md={2}
        className="tech-icons"
        onClick={() => openInNewTab("https://www.bigocheatsheet.com/")}
      >
        <FaB />
      </Col>
      <Col
        xs={4}
        md={2}
        className="tech-icons"
        onClick={() =>
          openInNewTab(
            "https://drive.google.com/file/d/1GS9Tjvhe-beCgr72xBGVDHnioqAnp_z9/view?usp=drive_link"
          )
        }
      >
        <SiPytorch />
      </Col>
      <Col
        xs={4}
        md={2}
        className="tech-icons"
        onClick={() =>
          openInNewTab(
            "https://drive.google.com/file/d/1W7O4w7RVUG7rhQgUWyhSBKynA_1v7M6L/view?usp=drive_link"
          )
        }
      >
        <GrDocker />
      </Col>
      <Col
        xs={4}
        md={2}
        className="tech-icons"
        onClick={() =>
          openInNewTab(
            "https://drive.google.com/file/d/1PF8_Mb1VIYUcxG9H0savgmcjlSRSNE9g/view?usp=drive_link"
          )
        }
      >
        <SiMysql />
      </Col>
      <Col
        xs={4}
        md={2}
        className="tech-icons"
        onClick={() =>
          openInNewTab(
            "https://drive.google.com/file/d/1JZMYJt0PU1TNhZMmaH_ernbRtvYnQyOU/view?usp=drive_link"
          )
        }
      >
        <DiGit />
      </Col>
      {/* <Col
        xs={4}
        md={2}
        className="tech-icons"
        onClick={() => openInNewTab("")}
      >
        <DiJava />
      </Col> */}
    </Row>
  );
}

export default CheatSheet;
